export const HELLO_MODAL_STORAGE_KEY = "ba-hello-modal-shown";

export const wasHelloModalShown = (): boolean =>
	localStorage.getItem(HELLO_MODAL_STORAGE_KEY) === "1";

export const markHelloModalShown = (): void => {
	localStorage.setItem(HELLO_MODAL_STORAGE_KEY, "1");
};
